import { render } from "./QuestionnaireMultiChoice.vue?vue&type=template&id=004bb4cd&scoped=true"
import script from "./QuestionnaireMultiChoice.vue?vue&type=script&lang=js"
export * from "./QuestionnaireMultiChoice.vue?vue&type=script&lang=js"

import "./QuestionnaireMultiChoice.vue?vue&type=style&index=0&id=004bb4cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004bb4cd"]])

export default __exports__